module.exports = __webpack_public_path__ + "static/img/dzbg_icon.png";